module.exports = __webpack_public_path__ + "img/26-jeep.4118eae4.png";